import escapeRegExp from "lodash/escapeRegExp";
import debounce from "lodash/debounce";

const VTS = (window.vts = window.vts || {});

jQuery(function () {
  const $emailForm = $("form[data-form-type=sign_in_v2_email]");
  const $passwordForm = $("form[data-form-type=sign_in_v2]");

  // Only activate on the v2 sign-in pages. The v1 module bails when a v2 form is
  // present, so the two flows never both bind to a page.
  if ($emailForm.length === 0 && $passwordForm.length === 0) {
    return;
  }

  // Both v2 forms post to #create and receive the same JSON as the v1 flow, so
  // the redirect/error handling is identical to v1 for both pages.
  const $signInForms = $emailForm.add($passwordForm);

  $signInForms
    .bind("ajax:success", function (evt, data) {
      if (data.disabled) {
        return VTS.setNotificationMessage({
          message: "Your account has been disabled. Please contact support@vts.com for assistance",
          selector: ".flash-message",
          type: "error",
        });
      } else if (data.unconfirmed) {
        return VTS.setNotificationMessage({
          message: "You have to confirm your account before continuing.",
          type: "error",
          selector: ".flash-message",
        });
      } else if (data.mri === true) {
        VTS.setNotificationMessage({
          message: "Redirecting you to the MRI portal.",
          selector: ".flash-message",
          type: "success",
        });

        return (window.location = data.location);
      } else if (data.sso === true) {
        VTS.setNotificationMessage({
          message: "Redirecting you to Single Sign On.",
          selector: ".flash-message",
          type: "success",
        });

        return (window.location = data.location);
      } else if (data.saml) {
        VTS.setNotificationMessage({
          message: "Redirecting you back to service provider",
          type: "success",
          selector: ".flash-message",
        });

        return (window.location = data.location);
      } else if (data.location != null) {
        return (window.location = data.location);
      }
    })
    .bind("ajax:error", function (evt, data) {
      // Non-JSON error responses (network timeout, 502, Rails HTML error page)
      // have no responseJSON, so fall back to a generic message instead of
      // throwing on a null property access.
      const message =
        (data && data.responseJSON && data.responseJSON.error) ||
        "Something went wrong. Please try again.";

      return VTS.setNotificationMessage({
        message: message,
        selector: ".flash-message",
        type: "error",
      });
    })
    .bind("ajax:before", function () {
      return VTS.removeNotificationMessage({
        selector: ".flash-message",
      });
    });

  // Email page: decide the auth method with the same lookup and VTS-exception
  // rules as v1. MRI/SSO users submit to #create (which redirects, records the
  // return_to, and audits the attempt — exactly the v1 path); password users are
  // sent to the password page.
  if ($emailForm.length) {
    const $email = $("#user_email");

    const emailIsValid = function (emailAddress) {
      return emailAddress.match(/^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i) != null;
    };

    const emailRegExp = function (email) {
      return new RegExp("s*" + escapeRegExp(email) + "s*", "i");
    };

    // These VTS accounts have SSO enabled but must still sign in with a password.
    const vtsExceptions = [
      "sales@viewthespace.com",
      "sales@vts.com",
      "beta@vts.com",
      "super-beta@vts.com",
      "big@viewthespace.com",
      "availabilitiesonly@vts.com",
      "availabilitiesandexisting@vts.com",
    ].map(emailRegExp);

    const isVTSException = function (emailAddress) {
      return vtsExceptions.some(function (exception) {
        return exception.test(emailAddress);
      });
    };

    let lastEmail = null;
    let lastRequest = null;

    const authMethodsFor = function (emailAddress) {
      if (!emailAddress || !emailIsValid(emailAddress)) {
        return null;
      }

      if (emailAddress !== lastEmail) {
        lastEmail = emailAddress;
        lastRequest = $.get(
          "/authc/sso/enabled?" + $.param({ email_address: emailAddress })
        ).fail(function () {
          if (lastEmail === emailAddress) {
            lastEmail = null;
            lastRequest = null;
          }
        });
      }

      return lastRequest;
    };

    // Live button label, matching v1: as a valid email is typed, reflect the
    // detected auth method ("Next" for MRI, "SSO Log In" for SSO, default
    // otherwise). Purely cosmetic — the click handler re-checks before acting.
    const $continueButton = $emailForm.find("button[type=submit]");
    const defaultButtonLabel = $continueButton.text();

    const updateButtonLabel = function () {
      const emailAddress = $email.val();
      const request = authMethodsFor(emailAddress);

      if (!request) {
        $continueButton.text(defaultButtonLabel);
        return;
      }

      request.then(function (data) {
        // Ignore a stale response if the email changed while it was in flight.
        if ($email.val() !== emailAddress) {
          return;
        }

        if (data["is_mri_only"]) {
          $continueButton.text("Go To MRI");
        } else if (data["is_sso_enabled"] && !isVTSException(emailAddress)) {
          $continueButton.text("SSO Log In");
        } else {
          $continueButton.text(defaultButtonLabel);
        }
      });
    };

    $email.on("keyup change", debounce(updateButtonLabel, 150));

    const goToPasswordPage = function () {
      const url = $emailForm.data("password-url");
      const separator = url.indexOf("?") === -1 ? "?" : "&";
      window.location = url + separator + $.param({ user: { email: $email.val() } });
    };

    // When we've decided it's an MRI/SSO login we flip this so the submit
    // handler lets rails-ujs POST the form to #create instead of intercepting.
    let proceedWithSubmit = false;

    $emailForm.on("submit", function (event) {
      if (proceedWithSubmit) {
        // One-shot: let this programmatic submit reach rails-ujs, then reset so a
        // later submit (e.g. after a failed POST + edited email) is re-evaluated
        // instead of blindly bypassing the email-step decision.
        proceedWithSubmit = false;
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const emailAddress = $email.val();
      if (!emailIsValid(emailAddress)) {
        return VTS.setNotificationMessage({
          message: "Please enter a valid email address.",
          selector: ".flash-message",
          type: "error",
        });
      }

      const request = authMethodsFor(emailAddress);
      if (!request) {
        return;
      }

      request
        .then(function (data) {
          const usesSso = data["is_sso_enabled"] && !isVTSException(emailAddress);

          if (data["is_mri_only"] || usesSso) {
            proceedWithSubmit = true;
            $emailForm.trigger("submit");
          } else {
            goToPasswordPage();
          }
        })
        .fail(function () {
          // If the lookup fails, fall through to the password page; #create still
          // redirects MRI/SSO users correctly when the password page submits.
          goToPasswordPage();
        });
    });
  }

  // Flash messages driven by query params — shown on either v2 page.
  if (/[?&]unauthorized=t/.test(location.href)) {
    VTS.setNotificationMessage({
      message: "Please login to continue.",
      type: "error",
      selector: ".flash-message",
    });
  }

  if (/[?&]unlocked=t/.test(location.href)) {
    VTS.setNotificationMessage({
      message: "Your account was successfully unlocked.",
      type: "success",
      selector: ".flash-message",
    });
  }

  if (/[?&]timeout=t/.test(location.href)) {
    VTS.setNotificationMessage({
      message: "Your session expired, please sign in again to continue.",
      type: "error",
      selector: ".flash-message",
    });
  }

  if (/[?&]disabled=t/.test(location.href)) {
    VTS.setNotificationMessage({
      message: "Your account has been disabled. Please contact support@vts.com for assistance.",
      type: "error",
      selector: ".flash-message",
    });
  }

  if (/[?&]confirmation=t/.test(location.href)) {
    VTS.setNotificationMessage({
      message: "Confirmation token invalid.",
      type: "error",
      selector: ".flash-message",
    });
  }

  if (/[?&]SAMLRequest=/.test(location.href)) {
    const serviceProviderName = $("[data-saml-service-provider-name]").data(
      "saml-service-provider-name"
    );

    if (serviceProviderName) {
      VTS.setNotificationMessage({
        message: "Please sign in to continue with " + serviceProviderName,
        type: "success",
        selector: ".flash-message",
      });
    }
  }

  // Layout chrome shared with the v1 page (marketing tiles + mobile continue).
  const marketingLinks = {
    ".marketing-top":
      "https://vodi.vts.com/?utm_source=product-page&utm_medium=Website&utm_campaign=2026-April-VODI-Platform-Login",
    ".marketing-left":
      "https://www.vts.com/vts-activate-office?utm_medium=web&utm_source=vts-login",
    ".marketing-right":
      "https://www.vts.com/product/new-releases?utm_medium=web&utm_source=vts-login",
  };

  Object.entries(marketingLinks).forEach(([container, link]) => {
    $(container).click(() => {
      const hasLink = $(container).find("a").length;

      if (!hasLink) {
        window.open(link, "_blank");
      }
    });
  });

  const topWrapper = jQuery(".signIn-page");
  jQuery(".continue-to-web a").on("click", function () {
    topWrapper.addClass("mobile-continue");
  });

  // Focus the field for whichever page rendered.
  if ($passwordForm.length) {
    $("#user_password").focus();
  } else {
    $("#user_email").focus();
  }
});
